<template>
  <div class="m-app__review">
    <div class="m-app__review-icon">
      <app-svg-icon :name="review.iconName"></app-svg-icon>
    </div>
    <span class="m-app__review-author">{{ review.author }}</span>
    <p class="m-app__review-text">{{ review.text }}</p>
    <div class="m-app__review-footer">
      <span class="m-app__review-date">{{ review.date }}</span>
      <div class="m-app__review-rating">
        <ul class="m-app__review-rating-info">
          <li class="m-app__review-rating-info-item">
            <app-svg-icon name="star"></app-svg-icon>
          </li>
          <li class="m-app__review-rating-info-item">
            <app-svg-icon name="star"></app-svg-icon>
          </li>
          <li class="m-app__review-rating-info-item">
            <app-svg-icon name="star"></app-svg-icon>
          </li>
          <li class="m-app__review-rating-info-item">
            <app-svg-icon name="star"></app-svg-icon>
          </li>
          <li class="m-app__review-rating-info-item">
            <app-svg-icon name="star"></app-svg-icon>
          </li>
        </ul>
        <span class="m-app__review-rating-value">5,0</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReviewItem',
  components: {
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  props: {
    review: {
      type: Object,
      require: true,
    },
  },
};
</script>

<style scoped lang="scss">
.svg-icon {
  &--like {
    width: 22px;
    height: 24px;
  }

  &--fire {
    width: 23px;
    height: 24px;
  }

  &--smile {
    width: 24px;
    height: 24px;
  }

  &--star {
    width: 16px;
    height: 15px;
  }
}

.m-app__review {
  position: relative;
  width: 404px;
  padding: 60px 30px 20px 30px;
  margin: 35px 0 0 0;
  background: #fff;
  border-radius: 20px;

  &-icon {
    position: absolute;
    top: -30px;
    left: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  }

  &-author {
    display: block;
    padding-bottom: 12px;
    font-size: 16px;
    line-height: 24px;
    color: #212833;
  }

  &-text {
    min-height: 100px;
    font-size: 18px;
    font-weight: 300;
    line-height: 24px;
    color: #000;
  }

  &-footer {
    display: flex;
  }

  &-date {
    font-size: 14px;
    font-weight: 300;
    line-height: 24px;
    color: #828282;
  }

  &-rating {
    display: flex;
    margin-left: auto;

    &-info {
      display: flex;
      padding: 0;
      margin: 0;
      list-style: none;

      &-item {
        margin-right: 7px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    &-value {
      margin-left: 20px;
      font-size: 14px;
      line-height: 24px;
      color: #212833;
    }
  }
}

@media (max-width: $xxs) {
  .m-app__review {
    width: 100%;
    padding: 50px 30px 40px;
    margin: 35px 0 0 0;

    &-icon {
      left: 50%;
      margin-left: -30px;
    }

    &-text {
      min-height: 50px;
      font-weight: 100;
    }

    &-rating {
      margin-left: 0;
    }

    &-footer {
      flex-direction: column;
    }

    &-date {
      padding-bottom: 10px;
    }
  }
}
</style>
